// @mui material components
import Card from "@mui/material/Card";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Arakan examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import AuthService from "services/auth-service";
import CrudService from "services/cruds-service";
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import FilterProject from "./filter-article";
import StatusOnIcon from "@mui/icons-material/Wifi";
import StatusOffIcon from "@mui/icons-material/WifiOff";
import { Tooltip, IconButton, Grid, Icon } from "@mui/material";

// import BookingCard from "examples/Cards/BookingCard";
import i18n from "i18n";
import MDAvatar from "components/MDAvatar";
import { Add, Edit, Height, Search } from "@mui/icons-material";
import dayjs from "dayjs";
import CustomerCell from "components/table/CustomerCell";
import DefaultCell from "components/table/DefaultCell";
import StatusCell from "components/table/StatusCell";
import MDButton from "components/MDButton";

function Articles() {
  let { state } = useLocation();
  const { t } = i18n;

  const ability = useAbility(AbilityContext);
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [limitChange, setLimitChange] = useState(false);
  const [sortVal, setSortVal] = useState(null);
  const [sortUrl, setSortUrl] = useState("&sort=-date_created");
  const [isAdmin, setIsAdmin] = useState(false);
  const [filterUrl, setFilterUrl] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const navigate = useNavigate();
  let { pathname } = useLocation();

  let route = pathname.split("/")[pathname.split("/").length - 1];

  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    (async () => {
      const { data } = await AuthService.getProfile();
      setIsAdmin(
        ability.can("edit", "article") || data.role?.name === "Administrator",
      );
    })();
  }, []);

  const getArticles = async (filUrl) => {
    const URL = `${filUrl ? `${filUrl}&page=${page}` : `&page=${page}`}`;
    const response = await CrudService.getData(
      `items/article?fields=*,translations.*,tags.tags_id.translations.name,gallery.*,author_id.translations.*${URL}${
        route === "news" ? "&filter[type][_eq]=n" : "&filter[type][_eq]=b"
      }&filter[translations][languages_code][_eq]=ar-SA`,
      true,
    );
    // const response = await CrudService.getArticles(
    //   URL,
    //   true,
    //   route === "news" ? "n" : "b"
    // );
    setData(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    getArticles(`${filterUrl || ""}${sortUrl}`);
  }, [page]);

  useEffect(() => {
    getArticles(`${filterUrl || ""}${sortUrl}`);
    setLimitChange(false);
  }, [limitChange]);

  useEffect(() => {
    if (page === 1) getArticles(`${filterUrl || ""}${sortUrl}`);
    else if (page !== 1) setPage(1);
  }, [filterUrl, sortUrl, route]);

  // const updateStatusHandler = async (e, data) => {
  //   // if status published and date failed null update it to date.now else if date failed exist let it as it is and dont update it
  //   console.log(data.date, dayjs().format("YYYY-MM-DD"));

  //   let obj;
  //   if (data.status === "published") obj = { status: "draft" };
  //   else obj = { status: "published" };
  //   if (!data.date) obj["date"] = dayjs().format("YYYY-MM-DD");
  //   await CrudService.updateArticleInfo(obj, data.id);

  //   getArticles(`${filterUrl || ""}${sortUrl}`);
  //   setNotification({
  //     value: true,
  //     text: t("statusChanged"),
  //   });
  // };

  useEffect(() => {
    let val;
    if (sortVal) {
      if (sortVal.id === "article")
        val =
          "translations.title&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "tag")
        val =
          "tags.tags_id.translations.name&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "description")
        val =
          "translations.description&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "summary")
        val =
          "translations.summary&filter[translations][languages_code][_eq]=ar-SA";
      else val = sortVal.id;
      setSortUrl(`&sort=${sortVal.desc ? "-" : "+"}${val}`);
    }
  }, [sortVal]);

  useEffect(() => {
    setTableData(getRows(data));
  }, [data]);

  // useEffect(() => {
  //   if (!state) return;
  //   setNotification({
  //     value: state.value,
  //     text: state.text,
  //   });
  // }, [state]);

  // useEffect(() => {
  //   if (notification.value === true) {
  //     setTimeout(() => {
  //       setNotification({
  //         value: false,
  //         text: "",
  //       });
  //     }, 5000);
  //   }
  // }, [notification]);

  // const clickShowArticleDetailsHandler = (id) => {
  //   navigate(`/news&bolgs/edit/${route}/${id}`);
  // };

  // const clickDeleteHandler = async (e, id) => {
  //   try {
  //     if (!confirm(t("confirmDelete"))) {
  //       e.nativeEvent.stopImmediatePropagation();
  //     } else {
  //       /*
  //       you must delete all follow up in this appointment
  //       .....
  //       .....
  //       */
  //       await CrudService.deleteAppointment(id);
  //       // the delete does not send a response
  //       // so I need to get again the appointments to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
  //       const response = await CrudService.getProjects(filterUrl);
  //       setData(response.data);
  //       setNotification({
  //         value: true,
  //         text: t("deleteSuccessfully"),
  //       });
  //     }
  //   } catch (err) {
  //     // it sends error is the category is associated with an item
  //     console.error(err);
  //     if (err.hasOwnProperty("errors")) {
  //       setNotification({
  //         value: true,
  //         text: err.errors[0].title,
  //       });
  //     }
  //     return null;
  //   }
  // };

  async function deleteArticleWithRelations(articleId) {
    try {
      if (!confirm(t("confirmDelete"))) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.removeItemWithFilter(`items/article_translations`, {
          query: {
            filter: {
              article_id: { _eq: articleId },
            },
          },
        });

        await CrudService.removeItemWithFilter(`items/article_tags`, {
          query: {
            filter: {
              article_id: { _eq: articleId },
            },
          },
        });

        await CrudService.deleteItem("article", articleId);

        console.log("تم الحذف بنجاح مع جميع العلاقات");
        getArticles(filterUrl);
        setNotification({
          value: true,
          color: "success",
          text: t("deleteSuccessfully"),
        });
      }
    } catch (error) {
      console.error("حدث خطأ أثناء الحذف:", error);
    }
  }

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.id,
        article: [
          row?.translations[0]?.title,
          {
            image: `${baseUrl}assets/${row?.web_pic}`,
          },
        ],
        name: row.translations[0].title,
        description: row.translations[0].description,
        summary: row.translations[0].summary,
        status: row.status,
        date: row.date,
        tags: row.tags,
        tag:
          row.tags
            ?.map((tag) => tag?.tags_id?.translations?.[0]?.name)
            ?.filter(Boolean)
            ?.join(", ") || "",
      };
    });
    return updatedInfo;
  };

  const col = useMemo(
    () => [
      {
        Header: t("title"),
        accessor: "article",
        Cell: ({ value: [name, data] }) => (
          <CustomerCell
            image={data.image}
            color={data.color || "dark"}
            name={name}
          />
        ),
      },
      {
        Header: "الوسوم",
        accessor: "tag",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "التاريخ",
        accessor: "date",
        hidden: false,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "الحالة",
        accessor: "status",
        hidden: false,
        Cell: ({ value }) => {
          let status;
          if (value === "published") {
            status = <StatusCell icon="done" color="success" status={""} />;
          } else if (value === "draft") {
            status = <StatusCell icon="close" color="error" status={""} />;
          } else {
            status = <StatusCell icon="replay" color="dark" status={""} />;
          }

          return status;
        },
      },
      // {
      //   Header: "التفاصيل",
      //   hidden: true,
      //   accessor: "description",
      //   Cell: ({ value }) => (
      //     <MDBox
      //       sx={{
      //         cursor: "pointer",
      //         maxHeight: 300,
      //         overflowY: "auto",
      //         maxWidth: 500,
      //       }}
      //     >
      //       <DefaultCell value={value} />
      //     </MDBox>
      //   ),
      // },
      {
        Header: "الملخص",
        accessor: "summary",
        hidden: true,
        Cell: ({ value }) => (
          <MDBox
            sx={{
              cursor: "pointer",
              maxHeight: 300,
              overflowY: "auto",
              maxWidth: 500,
            }}
          >
            <DefaultCell value={value} />
          </MDBox>
        ),
      },
      {
        Header: t("actions"),
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {/* {info.cell.row.original.status === "draft" ? (
                <Tooltip
                  title={t("changeStatus")}
                  onClick={(e) =>
                    updateStatusHandler(e, info.cell.row.original)
                  }
                >
                  <IconButton>
                    <StatusOffIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip
                  title={t("changeStatus")}
                  onClick={(e) =>
                    updateStatusHandler(e, info.cell.row.original)
                  }
                >
                  <IconButton>
                    <StatusOnIcon />
                  </IconButton>
                </Tooltip>
              )} */}
              {isAdmin && (
                // <Tooltip
                //   title={t("updateUser")}
                //   onClick={() =>
                //     navigate(
                //       `/news&bolgs/edit/${route}/${info.cell.row.original.id}`
                //     )
                //   }
                // >
                //   <IconButton>
                //     <Edit />
                //   </IconButton>
                // </Tooltip>
                <>
                  <MDButton
                    variant="outlined"
                    color={"info"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                    onClick={() =>
                      navigate(
                        `/news&bolgs/edit/${route}/${info.cell.row.original.id}`,
                      )
                    }
                  >
                    <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                    &nbsp;
                    <Tooltip title="فتح للتعديل">
                      <span> فتح للتعديل </span>
                    </Tooltip>
                  </MDButton>
                  <MDButton
                    variant="outlined"
                    color={"error"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                    onClick={() =>
                      deleteArticleWithRelations(info.cell.row.original.id)
                    }
                  >
                    <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                    &nbsp;
                    <Tooltip title="حذف المقال">
                      <span> حذف المقال </span>
                    </Tooltip>
                  </MDButton>
                </>
              )}
            </MDBox>
          );
        },
      },
    ],
    [isAdmin],
  );

  const clickAddHandler = () => {
    console.log(`/news&bolgs/add/${route}`);

    navigate(`/news&bolgs/add/${route}`);
  };

  const getCsvRows = (info) => {
    // let updatedInfo = info.map((row) => {
    //   let csv = {
    //     id: row.id,
    //     date_created: moment(row.date_created).format(format1),
    //     responsible: `${row.responsible_id.first_name} ${
    //       row.responsible_id.last_name ? row.responsible_id.last_name : ""
    //     }`,
    //     pationt: row.pationt_id.first_name,
    //     pationtPhone: row.pationt_id.phone,
    //     clinic: row.clinic_id.name,
    //     smsource: row.source_id.name,
    //     details: row.details,
    //     gclid: row.gclid,
    //     fbclid: row.fbclid,
    //     campaign: row.campaign,
    //     source: row.source,
    //     medium: row.medium,
    //     term: row.term,
    //     content: row.content,
    //     status: row.status_id.name,
    //   };
    //   const keys = Object.keys(csv);
    //   let csvObj = {};
    //   keys.forEach((element) => {
    //     csvObj[t(element)] = csv[element];
    //   });
    //   return csvObj;
    // });
    // return updatedInfo;
  };

  return (
    <DashboardLayout>
      <MDBox pb={3}>
        <MDBox mb={3}>
          <Card sx={{ mb: 1 }}>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium" color="info">
                {t(route)}
              </MDTypography>
              <MDBox>
                {isAdmin && (
                  // <IconButton size="large" onClick={clickAddHandler}>
                  //   <Add color="info" />
                  // </IconButton>
                  <MDButton
                    onClick={clickAddHandler}
                    variant="outlined"
                    color={"info"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;
                    <Tooltip title=" إضافة جديد">
                      <span>إضافة جديد </span>
                    </Tooltip>
                  </MDButton>
                )}
                {/* <IconButton
                  size="large"
                  onClick={() => setShowSettings(!showSettings)}
                >
                  <Search color="info" />
                </IconButton> */}
                <MDButton
                  onClick={() => setShowSettings(!showSettings)}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                  &nbsp;
                  <Tooltip title=" بحث">
                    <span>بحث </span>
                  </Tooltip>
                </MDButton>
                {/* <MDBox sx={{ cursor: "pointer" }}>
                    <CsvDownloadButton
                      sx={{ cursor: "pointer" }}
                      data={getCsvRows(data)}
                      style={{
                        backgroundColor: "rgb(37 37 39)",
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: "bold",
                        padding: "6px 24px",
                        borderRadius: "6px",
                      }}
                      delimiter=","
                    >
                      {t("export")}
                    </CsvDownloadButton>
                  </MDBox> */}
              </MDBox>
            </MDBox>
          </Card>
          {notification.value && (
            <MDAlert color="info" my="20px">
              <MDTypography variant="body2" color="white">
                {notification.text}
              </MDTypography>
            </MDAlert>
          )}
          <Grid container spacing={1}>
            <Grid item xs={12} lg={showSettings ? 9.5 : 12}>
              <DataTable
                setLimitChange={setLimitChange}
                table={{ columns: col, rows: tableData }}
                meta={meta}
                setPage={setPage}
                setSortVal={setSortVal}
                pageNum={page}
                isSorted={true}
                canAddCol={true}
                canSearch={false}
              />
            </Grid>
            {showSettings && (
              <Grid item xs={12} lg={2.5}>
                <Card>
                  <FilterProject
                    setFilterUrl={setFilterUrl}
                    filterUrl={filterUrl}
                  />
                </Card>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Articles;
